import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  getRolesRecords,
  getEmployeeRecords,
  setEmployeeDetailsById,
} from "./EmployeesSlice";
import { uploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";

export const AddEmployeeApi = (employeeDtls, pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Employee/AddEmployee`, employeeDtls)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(GetEmployeesApi(pagination));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Employee.Notification.EmployeeAddedSuccessfully"
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", e.response?.data, "");
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Employee.Notification.Anunexpectederroroccurredwhileaddingemployee"
    );
    return false;
  }
};

export const EditEmployeeApi = (employeeDtls, pagination) => (dispatch) =>
  new Promise((resolve, reject) => {
    try {
      dispatch(showLoader());
      postRequest(`api/Employee/EditEmployee`, employeeDtls)
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Employee.Notification.EmployeeUpdatedSuccessfully"
          );
          dispatch(GetEmployeesApi(pagination));
          resolve(res);
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            e.response?.data,
            ""
          );
          resolve(null);
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Employee.Notification.Anunexpectederroroccurredwhileupdatingemployee"
      );
      reject(e);
    }
  });

export const getRolesApi = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lookup/GetRolesLookup`)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(getRolesRecords(res?.data));
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Employee.Notification.Errorwhilefetchingroles"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Employee.Notification.Errorwhilefetchingroles"
    );
  }
};

export const GetEmployeesApi = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Employee/GetEmployeesList`, values)
      .then((res) => {
        dispatch(
          getEmployeeRecords({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Employee.Notification.Errorwhilefetchingemployees"
    );
  }
};

export const GetEmployeeByIdApi = (id) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Employee/GetEmployeeById?id=${id}`)
      .then((res) => {
        dispatch(setEmployeeDetailsById(res?.data));
        //dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Employee.Notification.Errorwhilefetchingemployeedetails"
    );
  }
};

export const AddEmployeeCertificateApi =
  (certdetails, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(`api/Employee/AddEmployeeCertificate`, certdetails)
        .then((res) => {
          dispatch(uploadAttachment(res?.data));
          dispatch(GetEmployeesApi(pagination));
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Employee.Notification.CertificateAddedSuccessfully" //Need to update
          );
          return true;
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            e.response?.data,
            ""
          );
          return false;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Employee.Notification.AnunexpectederroroccurredwhileaddingCertificate"
      );
      return false;
    }
  };

export const DeleteEmployeeCertificateApi =
  (id, identifier, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(
        `api/Employee/DeleteEmployeeCertificate?Id=${id}&formTypeId=${identifier}`,
        id
      )
        .then((res) => {
          dispatch(GetEmployeesApi(pagination));
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Employee.Notification.CertificateDeletedSuccessfully"
          );
          return true;
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            e.response?.data,
            ""
          );
          return false;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Employee.Notification.AnunexpectederroroccurredwhiledeletingCertificate" //Need to update
      );
      return false;
    }
  };
